import Vue from 'vue'
import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'
import 'firebase/storage'

import { config } from './config.js'
import VueFire from 'vuefire'

Vue.use(VueFire)

const firebase_project_alias = process.env.VUE_APP_FIREBASE_PROJECT_ALIAS || 'default'

export const config_obj = config[firebase_project_alias]

firebase.initializeApp(config_obj.firebase)

export const db = firebase.firestore()
export const auth = firebase.auth()
export const storage = firebase.storage().ref()

export const api_base_path = config_obj.api_base_path
const firestoreSettings = { timestampsInSnapshots: true }

db.settings(firestoreSettings)
